module.exports = __webpack_public_path__ + "img/Jeremiah-Chiu---Zoom-Room-1-p-1600.ad2e9a41.jpg";